import { SAM_POWER_USER_UP, SAM_SUPER_USER_UP } from '../common/constants/sam';
import { sam } from '../../DataAccessLayer/services';
import {
  faMemo,
  faUserCheck,
  faUserMagnifyingGlass,
  faSwapArrows,
  faUserMinus,
  faBlockQuestion,
  faMemoPad,
} from '@fortawesome/pro-light-svg-icons';

export const PageDetails = {
  sam: {
    id: 'studentAdvisorManagement',
    title: 'Student Advisor Management',
    url: 'sam',
    breadcrumbs: [{ title: 'Dashboard', href: '/' }],
  },
  'student-search': {
    id: 'studentSearch',
    page: 'student-search',
    title: 'Student Search',
    url: 'student-search',
    icon: faUserMagnifyingGlass,
    description: 'Bulk search for up to 1000 students by UIN.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Student Advisor Management', href: '/sam' },
    ],
  },
  'advisor-summary': {
    id: 'advisorSummary',
    page: 'advisor-summary',
    title: 'Advisor Summary',
    url: 'advisor-summary',
    required: [SAM_POWER_USER_UP],
    icon: faMemo,
    description: 'Get the deparmental count of students for each advisor.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Student Advisor Management', href: '/sam' },
    ],
  },
  'student-assigned': {
    id: 'advisorsAssignedStudents',
    page: 'student-assigned',
    title: 'Advisors Assigned Students',
    url: 'student-assigned',
    icon: faUserCheck,
    description: 'Search advisors and view the assigned students.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Student Advisor Management', href: '/sam' },
    ],
  },
  'student-change-major': {
    id: 'studentsWithDifferentMajor',
    page: 'student-change-major',
    title: 'Major Change Mismatch',
    url: 'student-change-major',
    icon: faSwapArrows,
    description: 'List students who selected a different major but have the old advisor assigned.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Student Advisor Management', href: '/sam' },
    ],
  },
  'student-unassigned': {
    id: 'unassignedStudents',
    page: 'student-unassigned',
    title: 'Unassigned Students',
    url: 'student-unassigned',
    icon: faUserMinus,
    description: 'Search departments for students needing an advising assignment.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Student Advisor Management', href: '/sam' },
    ],
  },
};

export const AdminPageDetails = {
  'auto-assignment-report': {
    id: 'autoAssignmentReport',
    page: 'auto-assignment-report',
    title: 'Auto Assignment Report',
    url: 'auto-assignment-report',
    required: [SAM_SUPER_USER_UP],
    label: 'Auto Assignment Report',
    icon: faMemoPad,
    description: 'View report of auto assignment successes and failures. ',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Student Advisor Management', href: '/sam' },
    ],
  },
  'diff-major-auto-unassignment-report': {
    id: 'diffMajorAutoUnassignmentReport',
    page: 'diff-major-auto-unassignment-report',
    title: 'Major Change Mismatch Unassignment Report',
    url: 'diff-major-auto-unassignment-report',
    required: [SAM_SUPER_USER_UP],
    label: 'Major Change Mismatch Unassignment Report',
    icon: faMemoPad,
    description: 'View report of students auto unassigned due to changed majors.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Student Advisor Management', href: '/sam' },
    ],
  },
  'student-missing-advisor-code': {
    id: 'studentsWithMissingAdvisorCode',
    page: 'student-missing-advisor-code',
    title: 'Students Missing Advisor Code',
    url: 'student-missing-advisor-code',
    required: [SAM_POWER_USER_UP],
    icon: faBlockQuestion,
    description: 'List students who do not have an advisor code.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Student Advisor Management', href: '/sam' },
    ],
  },
  'inactive-auto-unassignment-report': {
    id: 'inactiveAutoUnassignmentReport',
    page: 'inactive-auto-unassignment-report',
    title: 'Inactive Auto Unassignment Report',
    url: 'inactive-auto-unassignment-report',
    required: [SAM_SUPER_USER_UP],
    label: 'View Inactive Students Auto Unassignment Report',
    icon: faMemoPad,
    description: 'View report of students auto unassigned due to becoming inactive.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Student Advisor Management', href: '/sam' },
    ],
  },
  'rules-update-report': {
    id: 'rulesUpdateReport',
    page: 'rules-update-report',
    title: 'Rules Update Report',
    url: 'rules-update-report',
    required: [SAM_SUPER_USER_UP],
    label: 'View Rules Update Report',
    icon: faMemoPad,
    description: 'View list and files used to update the assignment rules.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Student Advisor Management', href: '/sam' },
    ],
  },
};

export const AdvisorTypes = [
  {
    type: 'A',
    label: 'All',
  },
  {
    type: 'P',
    label: 'Primary',
  },
  {
    type: 'S',
    label: 'Secondary',
  },
];

export const DefaultDepartment = {
  STVDEPT_CODE: 'All',
  STVDEPT_DESC: '',
  STVDEPT_INFO: '',
};

export const SiteCodeCampusMapping = {
  100: 'On Campus',
  500: 'Online - In VA',
  700: 'Online - Out of State',
  '8OU': 'International',
};
